
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

export const tabItemVariants = cva(
  "flex items-center justify-center gap-2 px-3 py-1 text-sm font-medium transition-all h-full",
  {
    variants: {
      state: {
        active: "text-mono-seasalt",
        inactive: "text-mono-frenchGray hover:text-mono-platinum"
      }
    },
    defaultVariants: {
      state: "inactive"
    }
  }
)

// Add the missing tabContainerVariants export
export const tabContainerVariants = cva(
  "inline-flex items-center justify-center rounded-md bg-transparent p-1.5",
  {
    variants: {
      size: {
        default: "gap-1",
        sm: "h-9 gap-0.5",
        lg: "h-11 gap-2"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
)

const Toggle = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  <button
    className={cn(
      "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground",
      className
    )}
    ref={ref}
    {...props}
  />
))
Toggle.displayName = "Toggle"

export { Toggle }
